module.exports = {"BEGIN":"/","BRANCHS":"/filiais","BRANCHS_FORM":"/filiais/novo","CLIENTS":"/clientes","CLIENTS_FORM":"/clientes/novo","HOME":"/dashboard","LOGIN":"/login","ROOM_LIVE":"/salaAoVivo","ROOMS":"/salas","ROOMS_NEW":"/salas/novo","VOUCHERS":"/vouchers","VOUCHERS_FORM":"/vouchers/novo"}


//////////////////
// WEBPACK FOOTER
// ./src/const/routes.json
// module id = 78
// module chunks = 0